var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLeftArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118.205,
    height: 59.519,
    viewBox: "0 0 118.205 59.519",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "S_Arrow",
    "data-name": "S Arrow",
    transform: "translate(118.205 58.827) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M995.5-213.02l27.831,29.068L995.5-154.884",
    transform: "translate(-905.846 213.02)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 116.271,
    transform: "translate(0 28.462)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeftArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/leftArrow.9d5ecfbe.svg";
export { ForwardRef as ReactComponent };